// extracted by mini-css-extract-plugin
export var generateAiSummaryButton = "_bv-1";
export var starIconBox = "_bv-2";
export var summaryTitle = "_bv-0";